<script lang="ts">
import { get } from 'svelte/store'
import { fly } from 'svelte/transition'

import Button from '@/components/core/Button.svelte'
import { testIds } from '@/constants'
import { isDisconnected } from '@/modules/app/connectionStatus'
import { BOT_REPLY_DELAY, isReplyProcessing, messages, type QuickReply, REPLIES_ID_SUFFIX } from '@/modules/messages'
import { t } from '@/modules/translations'

type Props = {
	messageId: string
	reply: QuickReply
	index: number
}

let { messageId, reply, index }: Props = $props()

const handleClick = (text: string) => () => {
	// Remove replies suffix ID
	if (get(isReplyProcessing)) return
	const id = messageId.replace(REPLIES_ID_SUFFIX, '')
	isReplyProcessing.set(true)
	void messages.sendBotReply(id, text, reply.payload)
}

let testId: string = $derived(reply.payload.isGoBackButton ? testIds.messageBotBack : testIds.messageBotReply)

let text = $derived.by(() => {
	const buttonText = reply.payload.translate ? $t(reply.text) : reply.text

	if (reply.payload.isGoBackButton) {
		return `↩️ ${buttonText}`
	} else {
		return buttonText
	}
})
</script>

<div
	in:fly|global={{ delay: BOT_REPLY_DELAY + index * 200, duration: 300, x: -20 }}
	class="mt-2 ml-2"
	data-testid={testId}
>
	<Button variant="outline" disabled={$isDisconnected} style={'height: fit-content'} onClick={handleClick(text)}>
		<p class="py-2 break-all">
			{text}
		</p>
	</Button>
</div>
